import { Flex, Box, Text, Button, Center,InputGroup,InputRightElement,Input,IconButton,useColorMode } from "@chakra-ui/react";
import { Icon, SearchIcon,Search2Icon } from "@chakra-ui/icons";
import useTranslation from "next-translate/useTranslation";
import { FiSearch } from "react-icons/fi";
import { useRouter } from "next/router";
import { useState,useEffect } from "react";
export default function PocsHeader({search}) {
  const { t } = useTranslation();
 const [inputValue, setInputValue] = useState(search || '');
  const {colorMode}=useColorMode();
 // Gérez les modifications de la valeur de l'input
 const handleInputChange = (e) => {
   setInputValue(e.target.value);
 };
useEffect(() => {
  search && setInputValue(search);
}, [search]);
  return (
    <Flex direction={{base:"column", lg:"row"}} w={"full"}>
      <Flex w={{base:"100%",lg:"70%"}} direction={{base:"column", lg:"row"}} justifyContent={"space-between"}>
        <Text color={"brand.500"} fontSize={"48px"} fontWeight={600}>
          {" "}
          POC{" "}
        </Text>

        {/* <Flex overflowX={{base:"auto",lg:"inherit"}}  sx={{
          scrollbarWidth: 'thin',
          scrollbarColor: 'gray transparent', 
          '&::-webkit-scrollbar': {
            width: '6px',
            height:"5px"
        },
          '&::-webkit-scrollbar-thumb': {
            background: 'gray', 
            borderRadius: '3px',
          },
        }}  my={{base:"20px",lg:"0px"}}   gap={"16px"} alignItems={"center"}>
          <Button
            borderRadius="96px"
            mb={{base:"3px",lg:"0"}}
            flex= {{base:"0 0 100px",lg:"auto" }}
            bgColor="#00B295"
            _hover={{ color: "inherit" }}
          >
            <Center>
              <Text fontSize="14px" fontWeight="500" color="#fff">
                {t("pocs:all")}
              </Text>
            </Center>
          </Button>
          <Button
            borderRadius="96px"
            bgColor="transparent"
            py={"8px"}
            px={"12px"}
            mb={{base:"3px",lg:"0"}}
            flex= {{base:"0 0 100px",lg:"auto" }}
            color={colorMode==='light'?"#565656":'white'}
            _hover={{ backgroundColor:"brand.500",color:"white" }}
            border={"1px solid rgba(196, 196, 196, 0.21)"}
          >
            <Center>
              <Text fontSize="14px" fontWeight="500">
              {t("pocs:cve")}

              </Text>
            </Center>
          </Button>
          <Button
            borderRadius="96px"
            bgColor="transparent"
            py={"8px"}
            mb={{base:"3px",lg:"0"}}
            px={"12px"}
            flex= {"0 0 100px"}
            color={colorMode==='light'?"#565656":'white'}
            _hover={{ backgroundColor:"brand.500",color:"white" }}
            border={"1px solid rgba(196, 196, 196, 0.21)"}
          >
            <Center>
              <Text fontSize="14px" fontWeight="500">
              {t("pocs:vulnerability")}

              </Text>
            </Center>
          </Button>
          <Button
            borderRadius="96px"
            bgColor="transparent"
            py={"8px"}
            px={"12px"}
            mb={{base:"3px",lg:"0"}}
            flex= {{base:"0 0 100px",lg:"auto" }}
            color={colorMode==='light'?"#565656":'white'}
            _hover={{ backgroundColor:"brand.500",color:"white" }}
            border={"1px solid rgba(196, 196, 196, 0.21)"}
          >
            <Center>
              <Text fontSize="14px" fontWeight="500">
              {t("pocs:alerts")}

              </Text>
            </Center>
          </Button>
          <Button
            borderRadius="96px"
            bgColor="transparent"
            py={"8px"}
            px={"12px"}
            mb={{base:"3px",lg:"0"}}
            flex= {{base:"0 0 100px",lg:"auto" }}
            color={colorMode==='light'?"#565656":'white'}
            _hover={{ backgroundColor:"brand.500",color:"white" }}
            border={"1px solid rgba(196, 196, 196, 0.21)"}
          >
            <Center>
              <Text fontSize="14px" fontWeight="500" >
              {t("pocs:integration")}

              </Text>
            </Center>
          </Button>
        </Flex> */}
      </Flex>

      <Flex w={{base:"100%",lg:"30%"}} as={"form"} alignItems="center" justifyContent={"end"}>
      <InputGroup h={"48px"} w={{base:"100%",lg:"90%"}} minW="230px"   >
            <Input
            borderColor={
              colorMode === "light" ? "inherit" : "brand.700"
              }
              bg={colorMode === "light" ? "white" : "transparent"}
              color={colorMode === 'light' ? 'inherit' : 'white'}
              _placeholder={{
              color: colorMode === "light" ? "inherit" : "gray.200",
              }}
              _hover={{
              bgColor:
                colorMode === "light" ? "white" : "transparent",
              }}
              _focus={{
                bgColor:
                colorMode === "light" ? "white" : "transparent",
              }
              }
            type="search" name="search" value={inputValue} onChange={handleInputChange} borderRadius="18px" placeholder={t("pocs:search_placeholder")} />
            <InputRightElement  >
            <IconButton aria-label='submit' variant="link" type="submit" icon={<SearchIcon mt="8px" color="gray.300" />}/>
             
            </InputRightElement>
        </InputGroup>
      </Flex>
    </Flex>
  );
}
